import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "nxsetup-outer native-auth" }
const _hoisted_2 = {
  key: 0,
  class: "setup-section"
}
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = {
  key: 1,
  class: "setup-section"
}
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = {
  key: 2,
  class: "setup-section"
}
const _hoisted_7 = { id: "folder-list" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "buttons" }

import { defineAsyncComponent, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

import NcButton from '@nextcloud/vue/components/NcButton';
import * as util from '@services/utils/common';
import * as nativex from '@native';
import { t } from '@services/l10n';
import XImg from '@components/frame/XImg.vue';

import banner from '@assets/banner.svg';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'NXSetup',
},
  __name: 'Setup',
  setup(__props) {

const NcCheckboxRadioSwitch = defineAsyncComponent(() => import('@nextcloud/vue/components/NcCheckboxRadioSwitch'));



const router = useRouter();

const hasMediaPermission = ref(false);
const step = ref(util.uid ? 1 : 0);
const localFolders = ref<nativex.LocalFolderConfig[]>([]);
const syncStatus = ref(-1);
let syncStatusWatch = 0;

watch(step, () => {
  switch (step.value) {
    case 2:
      hasMediaPermission.value = nativex.configHasMediaPermission();
      break;
    case 3:
      localFolders.value = nativex.getLocalFolders();
      break;
    case 4:
      router.replace('/');
      break;
  }
});

onBeforeMount(() => {
  if (!nativex.has() || !step.value) {
    router.replace('/');
  }
});

onMounted(async () => {
  await nextTick();

  // Match system bars to the auth pages (same as welcome/waiting)
  nativex.setTheme('#174a7d', true);

  // set up sync status watcher
  syncStatusWatch = window.setInterval(() => {
    if (hasMediaPermission.value && step.value === 3) {
      const newStatus = nativex.nativex.getSyncStatus();

      // Refresh local folders if newly reached state -1
      if (newStatus === -1 && syncStatus.value !== -1) {
        localFolders.value = nativex.getLocalFolders();
      }

      syncStatus.value = newStatus;
    }
  }, 500);
});

onBeforeUnmount(() => {
  nativex.setTheme(); // reset theme
  window.clearInterval(syncStatusWatch);
});

function updateDeviceFolders() {
  nativex.setLocalFolders(localFolders.value);
}

async function grantMediaPermission() {
  await nativex.configAllowMedia();
  hasMediaPermission.value = nativex.configHasMediaPermission();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "setup-step",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          class: "card",
          key: step.value
        }, [
          _createVNode(XImg, {
            class: "banner",
            src: _unref(banner),
            "svg-tag": true
          }, null, 8, ["src"]),
          (step.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'You are now logged in to the server!')) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)(
              'memories',
              'You can set up automatic uploads from this device using the Nextcloud mobile app. Click the button below to download the app, or skip this step and continue.',
            )) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(NcButton), {
                    variant: "secondary",
                    class: "button button-white",
                    href: "https://play.google.com/store/apps/details?id=com.nextcloud.client"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('memories', 'Set up automatic upload')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NcButton), {
                    variant: "primary",
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value++))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('memories', 'Continue')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (step.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_unref(t)(
              'memories',
              'Memories can show local media on your device alongside the media on your server. This requires access to the media on this device.',
            )) + " ", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(hasMediaPermission.value
              ? _unref(t)('memories', 'Access to media has been granted.')
              : _unref(t)(
                  'memories',
                  'Access to media is not available yet. If the button below does not work, grant the permission through settings.',
                )) + " ", 1),
                  _createElementVNode("div", _hoisted_5, [
                    (!hasMediaPermission.value)
                      ? (_openBlock(), _createBlock(_unref(NcButton), {
                          key: 0,
                          variant: "secondary",
                          class: "button button-white",
                          onClick: grantMediaPermission
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('memories', 'Grant permissions')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(NcButton), {
                      variant: hasMediaPermission.value ? 'secondary' : 'primary',
                      class: _normalizeClass(["button", { 'button-white': hasMediaPermission.value }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (step.value += hasMediaPermission.value ? 1 : 2))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(hasMediaPermission.value ? _unref(t)('memories', 'Continue') : _unref(t)('memories', 'Skip this step')), 1)
                      ]),
                      _: 1
                    }, 8, ["variant", "class"])
                  ])
                ]))
              : (step.value === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'Choose the folders on this device to show on your timeline.')) + " " + _toDisplayString(_unref(t)(
              'memories',
              'If no folders are visible here, you may need to grant the app storage permissions, or wait for the app to index your files.',
            )) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('memories', 'You can always change this in settings. Note that this does not affect automatic uploading.')) + " ", 1),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("div", _hoisted_7, [
                      (syncStatus.value != -1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_unref(t)('memories', 'Synchronizing local files ({n} done).', { n: syncStatus.value })) + " ", 1),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('memories', 'This may take a while. Do not close this window.')), 1)
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(localFolders.value, (folder) => {
                            return (_openBlock(), _createBlock(_unref(NcCheckboxRadioSwitch), {
                              key: folder.id,
                              modelValue: folder.enabled,
                              "onUpdate:modelValue": [($event: any) => ((folder.enabled) = $event), updateDeviceFolders],
                              type: "switch"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(folder.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                          }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(NcButton), {
                        variant: "secondary",
                        class: "button button-white",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value++))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('memories', 'Finish')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})